import Client from '@/repositories/Clients/AxiosClient'
import Config from '@/repositories/Clients/AxiosDefaultConfig'
import { prepareSearchParams } from '@/libs/helper'

const resource = `${Config.basePath}/v1/api/admin/match/video`

export default {
  index(payload) {
    const params = prepareSearchParams(payload)
    return Client.post(
      resource,
      params,
      {
        headers: {
          action: 'video-list',
        },
      },
    )
  },
  show(id, payload = {}) {
    const params = {
      ...payload,
      id,
    }
    return Client.post(resource, params, {
      headers: {
        action: 'video-show',
      },
    })
  },
  create(payload) {
    return Client.post(resource, payload, {
      headers: {
        action: 'video-store',
      },
    })
  },
  update(payload) {
    return Client.post(resource, payload, {
      headers: {
        action: 'video-update',
      },
    })
  },
}
